// firebase-config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyA4rnRS2bfmugdjqWQCRtrQ5dJYT5wf_qY",
  authDomain: "ourunitycommunity-68af1.firebaseapp.com",
  projectId: "ourunitycommunity-68af1",
  storageBucket: "ourunitycommunity-68af1.firebasestorage.app",
  messagingSenderId: "399683387004",
  appId: "1:399683387004:web:888728bee9e8a1d3d793f9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app);
